import script from "./MobileProposalVotes.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileProposalVotes.vue?vue&type=script&setup=true&lang=js"

import "./MobileProposalVotes.vue?vue&type=style&index=0&id=e61f7e9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e61f7e9a"]])

export default __exports__